import Header from './components/Header';
import Hero from './components/Hero';
import { ContactSection, RankingSection, MediaSection, AppSection, CommentsSection, IndexSection } from './components/SectionsA';
import { FeaturesSection, CarouselSection, TopicsSection, CardsSection } from './components/SectionsB';
import { UpdatesSection, AboutSection, FaqSection } from './components/SectionsC';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <ContactSection />
        <RankingSection />
        <MediaSection />
        <AppSection />
        <CommentsSection />
        <IndexSection />
        <FeaturesSection />
        <CarouselSection />
        <TopicsSection />
        <CardsSection />
        <UpdatesSection />
        <AboutSection />
        <FaqSection />
      </main>
      <Footer />
    </>
  );
}